<template>
  <div>
    <v-row v-if="documents.length > 1" ref="tabContainer">
      <v-col>
        <v-btn-toggle dense v-model="docMainIndex">
          <v-btn v-for="(dt, dti) in documents.filter((d, di) => di === 0)" :key="'ddt' + dti" @click="changeDoc(0)">
            {{ dt.doc_type }}</v-btn>
        </v-btn-toggle>
        <v-btn-toggle dense v-model="docLinkedIndex" class="float-right">
          <v-label class="mr-2 mt-3">Links:</v-label>
          <v-btn v-for="(dt, dti) in documents.filter((d, di) => di > 0)" :key="'dt' + dti" @click="changeDoc(dti + 1)">
            <v-icon left>mdi-link-variant</v-icon>{{ dt.doc_type }}</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-container v-if="document">
      <v-row v-for="(pt, pti) in document.partTypes.filter((x) =>
        partsVisible.some((pv) => pv === x.pt_name)
      )" :key="'pt' + pti" dense>
        <v-col>
          <DocSummaryPartType :partType="pt"></DocSummaryPartType>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import utils from "@/common/utils.js";
import DocStatus from "@/components/common/DocStatus";
import DocActionsMenu from "@/components/common/DocActionsMenu";
import Resizable from "@/components/common/Resizable";
import DocSummaryPartType from "@/components/common/DocSummaryPartType";

export default {
  name: "DocSummary",
  props: {
    doc_id: Number,
    alignRight: Boolean,
    text: String,
    icon: Boolean,
    iconName: String,
    checkBox: Boolean,
    altLayout: Boolean,
    showAsLink: Boolean,
    searchTerms: { type: [], required: false },
  },
  components: {
    DocSummaryPartType,
  },
  data: function () {
    const tW = 800;
    const tH = 800;
    return {
      utils: utils,
      document: null,
      documents: [],
      allPartTypes: null,
      partsVisible: [],
      title: null,
      show: false,
      selected: false,
      posX: 100,
      posY: 50,
      width: tW,
      height: tH,
      positionHorizontal: "left",
      positionVertical: "top",
      sizeWidth: "medium",
      sizeHeight: "large",
      busy: false,
      docActionsMenuContext: {
        show: false,
        busy: false,
        document: null,
        posX: 0,
        posY: 0,
      },
      settingsDialog: {
        show: false,
        posX: 0,
        posY: 0,
        partsVisible: [],
      },
      handlers: ["r", "rb", "b", "lb", "l", "lt", "t", "rt"],
      left: 100, //`calc( 50% - ${tW / 2}px)`,
      top: 100, //`calc(50% - ${tH / 2}px)`,
      maxW: 1000,
      maxH: 800,
      minW: 400,
      minH: 200,
      fit: true,
      event: "",
      dragSelector: ".drag-container",
      closeTrigger: 0,
      docMainIndex: 0,
      docLinkedIndex: -1,
    };
  },
  watch: {
    // "context.documents": function (newVal) {
    //   if (newVal) this.init();
    // },
    doc_id: function (newVal) {
      if (newVal) {
        this.getDoc();
      }
    },
  },
  mounted() {
    this.getDoc();
  },
  created() { },
  computed: {},
  methods: {
    getDoc() {
      if (!this.doc_id) return;

      this.show = true;
      if (!this.document) {
        this.busy = true;
        this.$store
          .dispatch("docs/getDocumentSummary", this.doc_id)
          .then((resp) => {
            this.documents = resp.data.Data.documents;
            this.document = this.documents[0];
            this.initDocument();
          })
          .then(() => {
            this.busy = false;
          }),
          (error) => {
            console.error(error);
          };
      } else {
        this.initDocument();
      }
    },
    changeDoc(index) {
      this.document = this.documents[index];
      this.initDocument();
      if (index === 0) {
        this.docMainIndex = 0;
        this.docLinkedIndex = -1;
      } else {
        this.docMainIndex = -1;
        this.docLinkedIndex = index - 1;
      }
    },
    initDocument() {
      if (this.document) {
        let settings = this.$loginState.getSetting(
          `docViewSettings_${this.document.doc_type}`,
          null
        );
        this.partsVisible = this.document.partTypes
          .filter(
            (p) =>
              !settings?.partsVisible?.length ||
              settings.partsVisible.some((pv) => pv === p.pt_name)
          )
          .map((p) => p.pt_name);
      }
    },
    openDocActionsMenuContext(event, document) {
      event.preventDefault();
      this.docActionsMenuContext.document = this.getDocById(document.doc_id);
      this.docActionsMenuContext.posX = event.clientX;
      this.docActionsMenuContext.posY = event.clientY;
      this.docActionsMenuContext.show = false;
      this.$nextTick(() => {
        this.docActionsMenuContext.show = true;
      });
    },
    getDocById(doc_id) {
      return this.$store.getters["docs/docsList"].find(
        (x) => x.doc_id === doc_id
      );
    },
    showSettings(event) {
      this.settingsDialog.show = true;
      this.settingsDialog.posX = event.clientX;
      this.settingsDialog.posY = event.clientY;
      this.settingsDialog.partsVisible = this.document.partTypes.map((p) => {
        return {
          pt_name: p.pt_name,
          visible: this.partsVisible.some((pv) => pv === p.pt_name),
        };
      });
    },
    showParts(show) {
      this.settingsDialog.partsVisible.forEach((x) => (x.visible = show));
    },
    saveSettings() {
      this.settingsDialog.show = false;
      this.partsVisible = this.settingsDialog.partsVisible
        .filter((x) => x.visible)
        .map((x) => x.pt_name);
      this.$loginState.saveSetting(
        `docViewSettings_${this.document.doc_type}`,
        {
          partsVisible: this.partsVisible,
        }
      );
    },
    openDocument(doc) {
      this.$emit("openDocument", doc);
    },
    selectDocument(doc) {
      // if (this.selected) this.$emit("selectDocument", doc);
      // else this.$emit("unselectDocument", doc);
      this.$emit("selectDocument", doc);
    },
  },
};
</script>
<style scoped>
</style>